import { useState, useEffect } from "react";

export function usePersistedState(key, defaultValue) {
  const [state, setState] = useState(() => {
    try {
      const persisted = sessionStorage.getItem(key);
      if (persisted !== null) {
        return JSON.parse(persisted);
      }
    } catch (e) {
      console.warn("Failed to parse persisted state", e);
    }
    return defaultValue;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      console.warn("Failed to save state to sessionStorage", e);
    }
  }, [key, state]);

  return [state, setState];
}
